'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var React = require('react');
var classes = require('classnames');
var nanoid = require('nanoid');
var Icon = require('../Icon/Icon.js');
var Spinner_module = require('./Spinner.module.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var classes__default = /*#__PURE__*/_interopDefaultLegacy(classes);

var Spinner = function (_a) {
    var _b, _c;
    var className = _a.className, contentLoaded = _a.contentLoaded, isCenteredHorizontally = _a.isCenteredHorizontally, isCenteredVertically = _a.isCenteredVertically, _d = _a.name, name = _d === void 0 ? 'Spinner' : _d, size = _a.size, variant = _a.variant;
    var uniqueId = React.useState(nanoid.nanoid())[0];
    return (jsxRuntime.jsxs("span", _tslib.__assign({ id: uniqueId, className: Spinner_module["default"].loader }, { children: [jsxRuntime.jsx(Icon["default"], { size: size, className: classes__default["default"](Spinner_module["default"].spinner, className, (_b = {}, _b[Spinner_module["default"].isCenteredHorizontally] = isCenteredHorizontally, _b), (_c = {}, _c[Spinner_module["default"].isCenteredVertically] = isCenteredVertically, _c)), name: name, variant: variant }), jsxRuntime.jsx("p", _tslib.__assign({ className: Spinner_module["default"].srOnly, role: "alert", "aria-live": "assertive" }, { children: contentLoaded ? 'Content has loaded' : 'Content is loading...' }))] })));
};

exports["default"] = Spinner;
//# sourceMappingURL=Spinner.js.map
